/**
 * Tiny module-level pub/sub that reports whether a lazy route chunk is being
 * fetched. The route <Suspense> fallback toggles it on mount/unmount and the
 * Layout shows a slim top progress bar while it is active.
 *
 * A module (rather than redux) is used on purpose: the fallback can mount
 * before/independently of the redux-connected tree and we don't want a chunk
 * fetch to trigger a full redux update.
 */
type RouteLoadingListener = (active: boolean) => void;

let activeCount = 0;
const listeners = new Set<RouteLoadingListener>();

export const getRouteChunkLoading = (): boolean => activeCount > 0;

export const setRouteChunkLoading = (active: boolean): void => {
    activeCount = Math.max(0, activeCount + (active ? 1 : -1));
    const nextActive = activeCount > 0;
    listeners.forEach((listener) => listener(nextActive));
};

export const subscribeRouteChunkLoading = (listener: RouteLoadingListener): (() => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};
